"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remintUiNodeIds = exports.remintDbArtifactIds = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const freshIdResolver = () => (0, uuid_1.v4)();
const remintDbArtifactIds = ({ artifacts, dependencies, idResolver = freshIdResolver, artifactDocumentId, onMissingDependencyId = 'assert', }) => {
    const idMap = new Map();
    const remintedArtifacts = artifacts.map((artifact) => {
        const newId = idResolver({ oldId: artifact.id, artifact });
        idMap.set(artifact.id, newId);
        return {
            ...artifact,
            id: newId,
            ...(artifactDocumentId === undefined ? {} : { artifactDocumentId }),
        };
    });
    const resolveEndpoint = (oldId) => {
        const newId = idMap.get(oldId);
        if (newId !== undefined) {
            return newId;
        }
        (0, common_1.finleyAssert)(onMissingDependencyId === 'keepOriginal', `[remintDbArtifactIds] dependency references unknown artifact id [${oldId}]`);
        // `keepOriginal`: the endpoint references a pre-existing (non-incoming)
        // artifact in the target doc, so leave its id untouched.
        return oldId;
    };
    const remintedDependencies = dependencies.map((dep) => ({
        outputArtifactId: resolveEndpoint(dep.outputArtifactId),
        inputArtifactId: resolveEndpoint(dep.inputArtifactId),
    }));
    return {
        artifacts: remintedArtifacts,
        dependencies: remintedDependencies,
        idMap,
    };
};
exports.remintDbArtifactIds = remintDbArtifactIds;
const freshUiNodeIdResolver = () => (0, uuid_1.v4)();
const remintUiNodeIds = (graph, idResolver = freshUiNodeIdResolver) => {
    const idMap = new Map();
    const remap = (oldId) => {
        const existing = idMap.get(oldId);
        if (existing !== undefined) {
            return existing;
        }
        const newId = idResolver(oldId);
        idMap.set(oldId, newId);
        return newId;
    };
    const nodes = graph.nodes.map((node) => {
        const oldId = node.metadata.tapeBuilderNodeId;
        const newId = remap(oldId);
        // The node configuration is opaque at this layer, but db-view nodes mirror
        // the id inside it; keep that consistent when present.
        const configuration = { ...node.configuration };
        if (configuration.id === oldId) {
            configuration.id = newId;
        }
        return {
            ...node,
            metadata: { ...node.metadata, tapeBuilderNodeId: newId },
            configuration,
        };
    });
    const edges = graph.edges.map((edge) => ({
        ...edge,
        source: remap(edge.source),
        target: remap(edge.target),
    }));
    return { nodes, edges };
};
exports.remintUiNodeIds = remintUiNodeIds;
//# sourceMappingURL=remintIds.js.map